import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { QuizOption } from '@services/quiz-chat-service';

@Component({
  selector: 'app-quiz-image-option-grid',
  templateUrl: './quiz-image-option-grid.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizImageOptionGridComponent {
  readonly options = input.required<QuizOption[]>();
  readonly disabled = input<boolean>(false);
  readonly showIndex = input<boolean>(false);
  readonly selectionChange = output<number>();

  private readonly selectedIndex = signal<number | null>(null);

  constructor() {
    effect(() => {
      this.options();
      this.selectedIndex.set(null);
    });
  }

  onOptionClick(index: number): void {
    if (this.disabled()) return;
    this.selectedIndex.set(index);
    this.selectionChange.emit(index);
  }

  /** Keyboard activation for the div-as-button cards (Enter/Space). */
  onOptionKeydown(index: number, event: Event): void {
    event.preventDefault();
    this.onOptionClick(index);
  }

  isSelected(index: number): boolean {
    return this.selectedIndex() === index;
  }

  imageUrl(option: QuizOption): string {
    return option.params?.imageUrl || '';
  }

  optionLabel(option: QuizOption): string {
    return option.text || option.value || '';
  }
}
